"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCarProperty = exports.carPropertyDefinition = void 0;
exports.carPropertyDefinition = {
    view: { label: 'Car Brand & Make' },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'car',
};
const isCarProperty = (prop) => {
    return prop.name === exports.carPropertyDefinition.name;
};
exports.isCarProperty = isCarProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FyLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY2FyLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscUJBQXFCLEdBQUc7SUFDbkMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGtCQUFrQixFQUFFO0lBQ25DLFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxLQUFLO0NBQ29CLENBQUE7QUFJMUIsTUFBTSxhQUFhLEdBQUcsQ0FBQyxJQUFrQixFQUF1QixFQUFFO0lBQ3ZFLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyw2QkFBcUIsQ0FBQyxJQUFJLENBQUE7QUFDakQsQ0FBQyxDQUFBO0FBRlksUUFBQSxhQUFhLGlCQUV6QiJ9